export const GET_TRANSACTION = 'CDL_CORPORATION/get_transaction';
export const APPROVE_TRANSACTION = 'CDL_CORPORATION/approve_transaction';
export const UPDATE_TRANSACTION = 'CDL_CORPORATION/update_transaction';
export const SHOW_TRANSACTION = 'CDL_CORPORATION/show_transaction';
export const START_ASSESSMENT = 'CDL_CORPORATION/start_assessment';
export const GET_SETTINGS = 'CDL_CORPORATION/get_settings';
export const UPDATE_TEST_STATUS = 'CDL_CORPORATION/update_health_status';
export const CEDULA_URI =
  'api/v1/administrators/transaction_histories/cedula/{id}/generate';
export const TAG_AS_PRINTED_TRANSACTION = 'CDL_INDIVIDUAL/tag_as_printed';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const OR_CHECK = 'CDL_INDIVIDUAL/or_check';
export const UPDATE_CDL = 'CDL_CORPORATION/update_cdl';
export const REGENERATE_CEDULA_URI =
  'api/v1/administrators/transaction_histories/cedula/{id}/regenerate';
export const UPDATE_AMOUNT = 'CDL_CORPORATION/update_amount';

export const GET_REGION = 'CDL_INDIVIDUAL/get_regions';
export const GET_PROVINCE = 'CDL_INDIVIDUAL/get_provinces';
export const GET_MUNICIPALITIES = 'CDL_INDIVIDUAL/get_municipalities';
export const GET_BARANGAYS = 'CDL_INDIVIDUAL/get_barangays';

export const GET_BUSINESS_LINES = 'GET_BUSINESS_LINES';
export const GET_BUSINESS_NATURE = 'GET_BUSINESS_NATURE';

export const GENERATE_OR_URI = 
'api/v1/administrators/transaction_histories/cedula/{id}/view_eor';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const CIVIL_STATUS = [
  {
    label: 'SINGLE',
    value: 'SINGLE',
  },
  {
    label: 'MARRIED',
    value: 'MARRIED',
  },
  {
    label: 'DIVORCED',
    value: 'DIVORCED',
  },
  {
    label: 'WIDOWED',
    value: 'WIDOWED',
  },
];

export const VALID_IDS = [
  {
    label: 'PASSPORT',
    value: 'PASSPORT',
  },
  {
    label: 'SSS',
    value: 'SSS',
  },
  {
    label: 'UMID',
    value: 'UMID',
  },
  {
    label: 'PHILHEALTH',
    value: 'PHILHEALTH',
  },
  {
    label: "DRIVER's LICENSE",
    value: "DRIVER's LICENSE",
  },
  {
    label: "VOTER's ID",
    value: "VOTER's ID",
  },
  {
    label: "SENIOR CITIZEN's ID",
    value: "SENIOR CITIZEN's ID",
  },
  {
    label: 'POSTAL ID',
    value: 'POSTAL ID',
  },
  {
    label: 'BARANGAY ID',
    value: 'BARANGAY ID',
  },
  {
    label: 'Authorization Letter',
    value: 'Authorization Letter',
  },
];

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};

export const CEDULA_EDIT_FORM = {
  barangay_code: '',
  president_authorized_representative: '',
  name_of_corporation_partnership: '',
  street: '',
  line_of_business_code: '',
  nature_of_business_code: '',
  date_of_registration: 'PHL',
  place_of_registration: '',
  tin: '',
  total_assessed_value_of_real_property: '',
  total_earnings_from_business: '',
  valid_id_to_present: 0,
  application_status_id: 0,
};
